export enum CMREventTypes {
	Generic = "Generic",
	ECMRModified = "ECMRModified",
	ECMRReset = "ECMRReset",
	ECMRIncident = "ECMRIncident",
	ECMRComment = "ECMRComment",
	ShipmentComment = "ShipmentComment",
    None = "None"
}
